<!-- car-table.component.html -->
<table mat-table [dataSource]="dataSource" class="mat-elevation-z8 custom-table" multiTemplateDataRows>

    <!-- Dynamic Column Definitions -->
    <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
        <!-- Header Cell -->
        <th mat-header-cell *matHeaderCellDef class="header-cell">
            {{ getColumnConfig(column)?.label || (column | titlecase) }}
        </th>

        <!-- Data Cell -->
        <td mat-cell *matCellDef="let element" class="data-cell">

            <!-- Show Progress Bar if needed -->
            <ng-container *ngIf="isProgressBarColumn(column); else normalCell">
                <div class="progress-container">
                    <span class="progress-label">{{ formatCellValue(getCellValue(element, column), column) }}</span>
                    <mat-progress-bar mode="determinate" [value]="getCellValue(element, column)"
                        [color]="getProgressColor(getCellValue(element, column))">
                    </mat-progress-bar>
                </div>
            </ng-container>

            <!-- Fallback for normal cells -->
            <ng-template #normalCell>
                {{ formatCellValue(getCellValue(element, column), column) }}
            </ng-template>

        </td>
    </ng-container>

    <!-- Row Definitions -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

</table>
